<template>
	<section>
        <div class="row">
            <div class="qualifier-tool-status-bar">
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">1</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">2</div>
                <div class="qualifier-tool-status-number">3</div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h3>{{model.Step2bTitle}}</h3>
                <p class="qualifier-tool-subheader">{{model.Step2bSubTitle}}</p>
            </div>
        </div>

        <div class="row d-flex justify-content-center">
            <div class="qualifier-tool-form-group">
                <p class="qualifier-tool-question">{{model.Step2bZipCodeTitle}}</p>
                <p class="qualifier-tool-question-sub">{{model.Step2bZipCodeSubTitle}}</p>
                <div class="qualifier-tool-question-input-container" ref="firstFocus" :class="{valid: fields.PostalCode && fields.PostalCode.valid}">
                    <input 
                        tabindex="0"
                        v-validate="'required|min:5|max:5|numeric|'" 
                        name="PostalCode" 
                        type="text" 
                        class="qualifier-tool-question-input" 
                        id="PostalCode" 
                        v-model="zipCode"
                        onkeydown="return ( event.ctrlKey || event.altKey || (47<event.keyCode && event.keyCode<58 && event.shiftKey==false) || (95<event.keyCode && event.keyCode<106)|| (event.keyCode==8) || (event.keyCode==9) || (event.keyCode>34 && event.keyCode<40) || (event.keyCode==46) )">
                    <label for="PostalCode"><span>{{model.Step2bZipCodePlaceholder}}</span></label>
                    <span class="error-label" v-if="vErrors.first('PostalCode')">{{model.ZipCodeValidMessage}}</span>
                </div>
                <p class="qualifier-tool-question-description">{{model.Step2bZipCodeDescription}}</p>
            </div>
            <div class="qualifier-tool-form-group">
                <p class="qualifier-tool-question">{{model.Step2bAgeTitle}}</p>
                <p class="qualifier-tool-question-sub">{{model.Step2bAgeSubTitle}}</p>
                <div class="qualifier-tool-form-container">
                    <input v-validate="'required'" type="radio" id="Is55OrOlder_yes" name="Is55orOlder" v-model="areYou55OrOlder" v-bind:value="true" required class="qualifier-tool-form-radio">
                    <label class="qualifier-tool-form-radio-label" for="Is55OrOlder_yes" tabindex="0" v-on:keyup.enter="enableIs55OrOlder(true)">{{model.PositiveResponseButtonText}}</label>
                    <input v-validate="'required'" type="radio" id="Is55OrOlder_no" name="Is55orOlder" v-model="areYou55OrOlder" v-bind:value="false" required class="qualifier-tool-form-radio">
                    <label class="qualifier-tool-form-radio-label" for="Is55OrOlder_no" tabindex="0" v-on:keyup.enter="enableIs55OrOlder(false)">{{model.NegativeResponseButtonText}}</label>
                    <span class="error-label" v-if="vErrors.first('Is55orOlder')">Please select one of these options.</span>
                </div>
                <p class="qualifier-tool-question-description">{{model.Step2bAgeDescription}}</p>
            </div>
        </div>

        <div class="row d-flex justify-content-center qualifier-tool-footer">
            <button type="button" class="qualifier-tool-btn" tabindex="0" @click="verifyZipCode()" v-bind:disabled="disableSubmit">{{model.SubmitButtonText}}</button>
        </div>
	</section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['model'],
		data: function () {
			return {
                zipCode: "",
                areYou55OrOlder: "",
                serviceableZip: false,
                disableSubmit: false
			}
		},
		computed: mapState({
            qtResponse: state => state.WebQualifierTool.qtResponse,
            formData: state => state.WebQualifierTool.formData,
            userIp: state => state.WebQualifierTool.userIp
		}),
		components: {
		},
		mounted: function () {
            let _this = this;
            setTimeout(() => {
                this.$refs.firstFocus.focus();
            }, 100);

            this.$store.subscribe((mutation, state) => {
				if (mutation.type === 'WebQualifierTool/setQTResponse') {
                    _this.serviceableZip = _this.qtResponse.IsPostalCodeValid;
                    _this.nextStepValidation();
                    _this.disableSubmit = false;
				}
			});
            if (window.dataLayer != null) {
                window.dataLayer.push({'event': 'Step2B'});    
            }
		},
		methods: {
            ...mapActions('WebQualifierTool', { updateStep: 'updateStep' }),
            ...mapActions('WebQualifierTool', { postData: 'postData' }),
            ...mapMutations('WebQualifierTool', { concurrentPostalCodeManager: 'concurrentPostalCodeManager' }),
            ...mapMutations('WebQualifierTool', { setLoadingState: 'setLoadingState' }),
            nextStepValidation() {
                if (this.serviceableZip) {
                    if (this.areYou55OrOlder) {
                        this.updateStep(9);
                        return;
                    }

                    this.updateStep(4);
                    return;
                }

                if (this.areYou55OrOlder) {
                    this.updateStep(6);
                    return;
                }

                this.updateStep(14);
            },
            verifyZipCode() {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        //Do nothing
                        return;
                    }

                    let data = {
                        "IsNewRequest": true,
                        "QualifierToolToSubmitModel": {
                            "PostalCode": this.zipCode,
                            "Is55OrOlder": this.areYou55OrOlder,
                            "SubmissionDate": new Date(),
                            "FormName": this.formData.formName,
                            "FormVersion": this.formData.formVersion,
                            "ReferringButton": this.formData.referringButton,
                            "ReferringPageURL": this.formData.urlReferrer,
                            "ReferringUTMQueryString": this.formData.utmData,
                        }
                    }
                    this.disableSubmit = true;
                    localStorage.setItem('ConcurrentZipCode', this.zipCode);
                    this.setLoadingState(true);
                    this.postData(data);
                    if (window.dataLayer != null) {
                        window.dataLayer.push({'event': 'Step2B.FormSubmission'});    
                    }
                });
            },
            enableIs55OrOlder(state) {
                this.areYou55OrOlder = state;
            }
        },
    }
</script>